import type { FunctionalComponent as FC } from 'vue';
import IconPark from '~/components/iconPark/index.vue';
import { copyToClipboard } from '~/utils';

const copy = (msg?: string, eventName?: TRACK_EVENT, trackParams?: any, onClose?: () => void) => {
  const { $t } = useNuxtApp();
  if (!msg) {
    return;
  }
  if (eventName) {
    trackEvent(eventName, {
      ...trackParams,
      share_mode: 2,
    });
  }
  try {
    copyToClipboard(msg);
    message.success($t('fu-zhi-cheng-gong'));
    onClose?.();
  } catch (error) {
    console.error(error);

    message.error($t('wen-ben-fu-zhi-shi-bai'));
  }
};

export const ShareLink: FC<{
  url?: string;
  hasTitle?: boolean;
  eventName: TRACK_EVENT | string;
  trackParams?: any;
  desc?: string;
  name?: string;
  gif?: string;
  bg?: string;
  disabled?: boolean;
  text?: string;
  onClose?: () => void;
}> = props => {
  const { $t } = useNuxtApp();
  const flag = props.hasTitle !== undefined ? props.hasTitle : true;
  return [
    flag && (
      <div class="text-14 font-semibold mb-[10px] flex-y-center text-font-1">
        {props.name || $t('fen-xiang-gei-wai-bu-yong-hu')}
        {props.desc && (
          <a-popover
            placement="bottomRight"
            destroyPopupOnHide
            content={
              <div class="p-[8px] w-[544px]">
                <img src={props.gif} class="w-[528px] h-[298px]" loading="lazy" />
                <div class="text-16 font-semibold mt-[16px]">{props.name}</div>
                <div class="mt-[12px]">
                  <span class="text-14 text-font-60">{props.desc}</span>
                </div>
              </div>
            }
          >
            <svg viewBox="0 0 16 16" class="w-[1em] h-[1em]" xmlns="http://www.w3.org/2000/svg">
              <path
                data-follow-fill="#121926"
                fill-rule="evenodd"
                opacity=".5"
                fill="#121926"
                d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1.188a5.813 5.813 0 0 0 0 11.624A5.813 5.813 0 0 0 8 2.188ZM8.375 7c.069 0 .125.056.125.125v4.25a.125.125 0 0 1-.125.125h-.75a.125.125 0 0 1-.125-.125v-4.25c0-.069.056-.125.125-.125ZM8 4.5A.75.75 0 1 1 8 6a.75.75 0 0 1 0-1.5Z"
              />
            </svg>
          </a-popover>
        )}
      </div>
    ),
    <div class="flex-between gap-x-[12px]">
      <a-button
        type="primary"
        class="w-full !flex items-center justify-center"
        disabled={!props.url || props.disabled}
        onClick={() =>
          copy(props.text || props.url, props.eventName, props.trackParams, props.onClose)
        }
        icon={<IconPark class="text-[14px] mr-[4px] top-[2px]" name="link-e97pp5lm" />}
      >
        {$t('fu-zhi-lian-jie')}
      </a-button>
    </div>,
  ];
};
